function hexToHsl(hex: string) {
  hex = hex.replace('#', '')
  const r = parseInt(hex.slice(0, 2), 16) / 255
  const g = parseInt(hex.slice(2, 4), 16) / 255
  const b = parseInt(hex.slice(4, 6), 16) / 255

  const max = Math.max(r, g, b),
    min = Math.min(r, g, b)
  let h,
    s,
    l = (max + min) / 2

  if (max === min) {
    h = s = 0 // achromatic
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h = (h ?? 0) / 6
  }
  return { h: h * 360, s: s * 100, l: l * 100 }
}

function hslToHex(h: number, s: number, l: number) {
  s = s / 100
  l = l / 100
  const k = (n: number) => (n + h / 30) % 12
  const a = s * Math.min(l, 1 - l)
  const f = (n: number) => {
    const color =
      l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0')
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

/**
 *
 * @param hex hex color code with #
 * @param amount  number of lighter shade you want, 20 means much ligher and lower number means less lighter, clamped at 100
 * @returns hex code which is lighter and compliments the original hex color
 */
export const lightenColor = (hex: string, amount: number) => {
  const { h, s, l } = hexToHsl(hex)
  const MAX_LIGHTNESS = 95 // stay below 100 so it never becomes white
  return hslToHex(h, s, Math.min(MAX_LIGHTNESS, l + amount))
}

/**
 *
 * @param hex hex color code
 * @param hueShift how much of a different color do you want from the one you are sending to this helper
 * @param lightenBy how much lighter
 * @returns hex code for new color
 */
export const getComplementColor = (
  hex: string,
  hueShift = 30,
  lightenBy = 8,
) => {
  const { h, s, l } = hexToHsl(hex)
  const newHue = (h + hueShift + 360) % 360
  const newL = Math.min(100, Math.max(0, l + lightenBy))
  return hslToHex(newHue, s, newL)
}
